module.exports = __webpack_public_path__ + "media/telphone2.5e96c0b0.mp3";